import { css } from '@emotion/react';

import { scrollBarStyling } from 'src/styles/styles';

import { colors } from '../../styles/colors';
import { MediaBP as MQ } from '../../styles/mediaQuery';

export const modalOverlay = ({ removeBackdrop = false }) => css`
  position: fixed;
  ${!removeBackdrop ? 'top: 0' : ''};
  ${removeBackdrop ? 'bottom: 0' : ''};
  left: 0;
  width: 100%;
  height: ${removeBackdrop ? 'auto' : '100%'};
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${removeBackdrop
    ? colors.Transparent
    : colors.PortalTransparentBg};
  z-index: 1000;
`;

export const modalContainer = ({
  width = '400px',
  handleResponseForSm = false,
  handleResponseForMobileXs = false,
  height = '500px',
  background = `${colors.white}`,
  margin = '0px',
  border = '',
  overflow = '',
  maxHeight = 'auto',
  cssClassName = '',
  isCommercePopup = false
}) =>
  css`
    margin: 10px;
    background: ${background};
    overflow: ${overflow};
    z-index: 100;
    border: ${border};
    ${scrollBarStyling(
      '6px',
      colors.PrimaryWhiteColorAlpha20,
      colors.PrimaryWhiteColorAlpha15
    )}
    ${MQ.MobileXs} {
      border-radius: 10px 10px 0 0;
      ${handleResponseForMobileXs
        ? `position: relative;
         width: ${width};
         height: ${height};
         max-height: ${maxHeight};
         border-radius: 10px;`
        : `position: absolute;
          ${isCommercePopup ? `height: ${height}` : ''}
          bottom: 0;
          width: 100%;
        `}
    }
    ${!handleResponseForSm ? MQ.MediaMd : MQ.MediaSm} {
      position: relative;
      width: ${width};
      height: ${height};
      max-height: ${maxHeight};
      border-radius: 10px;
    }
    ${cssClassName === 'referralExitNudge'
      ? `${MQ.MobilePortrait} {
          top: 90px;
          height: auto;
          width: 336px;
        }

        ${MQ.MediaSm} {
          top: 60px;
          width: 380px;
        }

        ${MQ.MediaMd} {
          top: 10%;
          height: auto;
          position: absolute;
          max-height: 410px;
          bottom: 10%;
          width: 747px;
        }

        ${MQ.MediaLg} {
          width: 738px;
        }
      `
      : ``}
  `;

export const modalHeader = ({
  closeIconColor = `${colors.black}`,
  separateCloseIcon = false,
  handleResponseForMobileXs = false
}) =>
  css`
    margin: 5px;
    display: flex;
    justify-content: flex-end;
    font-size: 15px;
    font-weight: 700;
    color: ${closeIconColor};
    ${!separateCloseIcon ? MQ.MediaMdMaxWidth : MQ.MobileXs} {
      top: ${handleResponseForMobileXs ? 10 : -40}px;
      color: ${colors.white};
      background: ${handleResponseForMobileXs
        ? colors.Transparent
        : colors.HlsaBlackColor};
      align-items: center;
      border-radius: 18px;
      justify-content: center;
      width: 25px;
      height: 25px;
    }
  `;
export const modalBody = ({
  padding = '16px',
  maxHeight = 'auto',
  cssClassName = '',
  isCommercePopup = false
}) =>
  css`
    position: relative;
    padding: ${padding};
    height: ${isCommercePopup ? 88 : 100}%;
    width: 100%;
    min-height: fit-content;
    overflow: ${isCommercePopup ? 'intial' : 'auto'};
    max-height: ${maxHeight};
    ${scrollBarStyling(
      '5px',
      colors.AccentScrollBarTrack,
      colors.PrimaryBlackColorAlpha20,
      '4px 0px'
    )};
    ${MQ.MediaMd} {
      min-height: unset;
    }

    ${cssClassName === 'referralExitNudge'
      ? `${MQ.MobilePortrait} {
      position: absolute;
      bottom: 0;
      top: 0;
      left: 0;
      right: 0;
      }
    `
      : ``}
  `;

export const closeButton = css`
  cursor: pointer;
  width: 25px;
  height: 25px;
  ${MQ.MediaMdMaxWidth} {
    width: 18px;
    height: 18px;
  }
`;
